import { render, staticRenderFns } from "./SolicitudStock.vue?vue&type=template&id=3800decc&"
import script from "./SolicitudStock.vue?vue&type=script&lang=ts&"
export * from "./SolicitudStock.vue?vue&type=script&lang=ts&"
import style0 from "./SolicitudStock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports